
import {
  UPDATE_RX_CONFIGURATOR_SCRIPTS_LOADED,
  UPDATE_RX_CONFIGURATOR_SET_IS_OPEN,
  UPDATE_PRESCRIPTION_DATA_LOADING,
  UPDATE_PRESCRIPTION_DATA_ERROR,
  UPDATE_PRESCRIPTION_DATA_UPDATED,
  UPDATE_PRESCRIPTION_DATA_RESET, UPDATE_PRESCRIPTION_CART_ITEM_DATA,
  UPDATE_RX_WARRANTY_PRICE,
} from '@store/mutations/prescription'
import { Commit } from 'vuex'
import {SghPrescriptionData} from '@interfaces/prescription'

export const ACTION_RX_CONFIGURATOR_SCRIPTS_LOADED = 'ACTION_RX_CONFIGURATOR_SCRIPTS_LOADED'
export const ACTION_RX_CONFIGURATOR_SET_IS_OPEN = 'ACTION_RX_CONFIGURATOR_SET_IS_OPEN'
export const ACTION_PRESCRIPTION_DATA_LOADING = 'ACTION_PRESCRIPTION_DATA_LOADING'
export const ACTION_PRESCRIPTION_DATA_ERROR = 'ACTION_PRESCRIPTION_DATA_ERROR'
export const ACTION_PRESCRIPTION_DATA_UPDATED = 'ACTION_PRESCRIPTION_DATA_UPDATED'
export const ACTION_PRESCRIPTION_CART_ITEM_DATA_UPDATE = 'ACTION_PRESCRIPTION_CART_ITEM_DATA_UPDATE'
export const ACTION_PRESCRIPTION_DATA_RESET = 'ACTION_PRESCRIPTION_DATA_RESET'
export const ACTION_RX_WARRANTY_PRICE = 'ACTION_RX_WARRANTY_PRICE'
export const actions = {
  [ACTION_RX_CONFIGURATOR_SCRIPTS_LOADED] :async function({ commit }: { commit: Commit }, payload:boolean) {
    commit(UPDATE_RX_CONFIGURATOR_SCRIPTS_LOADED, payload)
  },
  [ACTION_RX_CONFIGURATOR_SET_IS_OPEN] :async function({ commit }: { commit: Commit }, payload:boolean) {
    commit(UPDATE_RX_CONFIGURATOR_SET_IS_OPEN, payload)
  },
  [ACTION_PRESCRIPTION_DATA_LOADING] :async function({ commit }: { commit: Commit }, payload: boolean) {
    commit(UPDATE_PRESCRIPTION_DATA_LOADING, payload)
  },
  [ACTION_PRESCRIPTION_DATA_ERROR] :async function({ commit }: { commit: Commit }, payload:string | null) {
    commit(UPDATE_PRESCRIPTION_DATA_ERROR, payload)
  },
  [ACTION_PRESCRIPTION_DATA_UPDATED] :async function({ commit }: { commit: Commit }, payload: SghPrescriptionData) {
    commit(UPDATE_PRESCRIPTION_DATA_UPDATED, payload)
  },
  [ACTION_PRESCRIPTION_CART_ITEM_DATA_UPDATE] :async function({ commit }: { commit: Commit }, payload: {
    productUPC?: string | null;
    catEntryId?: string | null;
    orderItemId?: string | null;
    lensUPC?: string | null;
  }) {
    commit(UPDATE_PRESCRIPTION_CART_ITEM_DATA, payload)
  },
  [ACTION_PRESCRIPTION_DATA_RESET] :async function({ commit }: { commit: Commit }) {
    commit(UPDATE_PRESCRIPTION_DATA_RESET)
  },
  [ACTION_RX_WARRANTY_PRICE] :async function({ commit }: { commit: Commit }, payload: string) {
    commit(UPDATE_RX_WARRANTY_PRICE, payload)
  },
}
